import type { HseDetail, HseWorkOrderInput } from './types.js';

/**
 * Rapordan iş emri isteği (ADR 0097 §7). Hedef tarih yalnız raporun hedef tarihinden farklıysa
 * gönderilir: sunucu tarih verilmezse raporunkine düşer (packages/db hse/reports.ts). 1.0.40xx
 * öncesi gemi sunucuları tarihli isteği biçim hatasıyla reddettiği için varsayılan akış böylece
 * her sunucuda çalışır (ADR 0138 Ek 2026-11-02).
 */
export function workOrderInput(
  reportTargetDate: string | null,
  value: { equipmentId: string | null; title: string; targetOn: string | null },
): HseWorkOrderInput {
  return {
    equipmentId: value.equipmentId,
    title: value.title.trim(),
    ...(value.targetOn && value.targetOn !== reportTargetDate ? { targetOn: value.targetOn } : {}),
  };
}

function codeOf(error: unknown): unknown {
  return (error as { code?: unknown } | null)?.code;
}

/**
 * İş emrini açar. Seçilen farklı tarih eski sunucuda `VALIDATION_FAILED` alırsa istek tarihsiz bir
 * kez yinelenir (sunucu yazmadan önce reddetmiştir; ikinci iş emri `HSE_WORK_ORDER_EXISTS` ile
 * engellenir) ve `dateDropped` döner: kullanıcıya tarihin PMS iş emrinde düzeltilmesi söylenir.
 * Yineleme de düşerse ilk hata döner.
 */
export async function createHseWorkOrder(
  workOrder: (id: string, input: HseWorkOrderInput) => Promise<HseDetail>,
  reportId: string,
  input: HseWorkOrderInput,
): Promise<{ detail: HseDetail; dateDropped: boolean }> {
  try {
    return { detail: await workOrder(reportId, input), dateDropped: false };
  } catch (error) {
    if (!input.targetOn || codeOf(error) !== 'VALIDATION_FAILED') throw error;
    const { targetOn: _dropped, ...rest } = input;
    try {
      return { detail: await workOrder(reportId, rest), dateDropped: true };
    } catch {
      throw error;
    }
  }
}
